import { hooks } from '@approvalmax/utils';
import { useSelector } from 'modules/react-redux';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { useState } from 'react';
import { useGetNetSuiteDictionariesTaxCodes } from 'shared/data/webApp/v1';

export const useTaxCodes = (subsidiaryId?: string | null) => {
    const request = useSelector(requestSelector);

    const [query, setQuery] = useState('');
    const queryDebounced = hooks.useDebounce(query, 500);

    const { data, isFetching } = useGetNetSuiteDictionariesTaxCodes(
        {
            query: {
                companyId: request.companyId,
                subsidiaryId,
                ...(queryDebounced ? { query: queryDebounced } : {}),
            },
        },
        {
            enabled: !!subsidiaryId,
            staleTime: 1000 * 60,
        }
    );

    return {
        items: !subsidiaryId ? [] : data?.values ?? [],
        isFetching,
        setQuery,
    };
};
